import { useState } from "react";

import { useTimeout } from "usehooks-ts";

type Props = {
  text: string;
  delay: number;
};

export const PlainTextMention: React.FC<Props> = ({ text, delay }) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && <span className="ql-editor whitespace-pre-wrap">{text}</span>
  );
};
